(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-404"]) return;
  try {
    
  function ttpCarryMissingPart() {
    const path = window.location.pathname;
    if (path.length > 240 || !/^\/(?:products|pages)\/[a-zA-Z0-9_-]+\/?$/.test(path)) return;
    document.querySelectorAll('[data-ttp-recovery-link]').forEach(function(link) {
      const destination = new URL(link.href, window.location.origin);
      destination.searchParams.set('part_request_path', path);
      link.href = destination.pathname + destination.search;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ttpCarryMissingPart, { once: true });
  } else {
    ttpCarryMissingPart();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('ttp-product-gallery')) {
  customElements.define('ttp-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      if (!this.slides.length) return;
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-gallery-thumb]');
        const slide = event.target.closest('[data-gallery-slide]');
        if (thumbnail) { event.preventDefault(); this.show(Number(thumbnail.dataset.galleryIndex)); }
        if (slide && this.dialog && typeof this.dialog.showModal === 'function') {
          event.preventDefault(); this.opener = slide; this.updateZoom(); this.dialog.showModal();
        }
        if (event.target.closest('[data-gallery-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-gallery-next]')) this.show(this.index + 1);
        if (event.target.closest('[data-gallery-close]')) this.dialog.close();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close', () => this.opener?.focus());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      const stage = this.querySelector('.ttp-gallery-stage');
      stage.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY }; });
      stage.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', () => { this.touchStart = null; });
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === this.index)));
      this.querySelector('[data-gallery-counter]').textContent = (this.index + 1) + ' / ' + this.slides.length;
      this.querySelector('[data-gallery-caption-text]').textContent = this.slides[this.index].dataset.galleryCaption;
      if (this.dialog.open) this.updateZoom();
    }
    updateZoom() {
      const current = this.slides[this.index];
      const image = this.querySelector('[data-gallery-enlarged]');
      image.src = current.href;
      image.alt = current.dataset.galleryCaption;
      this.querySelector('[data-gallery-zoom-caption]').textContent = (this.index + 1) + ' / ' + this.slides.length + ' — ' + current.dataset.galleryCaption;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttp-contact-form"] && !Shopify.designMode) return;
  try {
    
  if (!window.ttpFormAccountabilityLoaded) {
    window.ttpFormAccountabilityLoaded = true;
    document.addEventListener('submit', function(event) {
      const form = event.target.closest('form.ttp-form');
      if (!form || form.dataset.ttpForwarding === 'true') return;
      const formTypeField = form.querySelector('[data-ttp-form-type]');
      const receiverField = form.querySelector('[data-ttp-receiver-url]');
      const receiverUrl = receiverField ? receiverField.value : '';
      if (!receiverUrl || receiverUrl.indexOf('/exec') === -1) return;

      event.preventDefault();
      form.dataset.ttpForwarding = 'true';

      const frameName = 'ttp-accountability-' + Date.now();
      const frame = document.createElement('iframe');
      frame.name = frameName;
      frame.hidden = true;
      document.body.appendChild(frame);

      const forward = document.createElement('form');
      forward.method = 'post';
      forward.action = receiverUrl;
      forward.target = frameName;
      forward.hidden = true;

      const values = { formType: formTypeField ? formTypeField.value : '' };
      form.querySelectorAll('[data-accountability-field]').forEach(function(field) {
        values[field.dataset.accountabilityField] = field.value;
      });

      Object.keys(values).forEach(function(key) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = values[key] || '';
        forward.appendChild(input);
      });

      document.body.appendChild(forward);
      forward.submit();
      window.setTimeout(function() { form.submit(); }, 700);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttp-parts-request-form"] && !Shopify.designMode) return;
  try {
    
  function ttpRestorePartReference() {
    const requestedPath = new URLSearchParams(window.location.search).get('part_request_path');
    if (!requestedPath || requestedPath.length > 240 || !/^\/(?:products|pages)\/[a-zA-Z0-9_-]+\/?$/.test(requestedPath)) return;
    document.querySelectorAll('form.ttp-form').forEach(function(form) {
      const originalPage = form.querySelector('[data-ttp-original-page]');
      const partField = form.querySelector('[name="contact[part_needed]"]');
      if (!originalPage || !partField) return;
      originalPage.value = window.location.origin + requestedPath;
      if (requestedPath.startsWith('/products/') && !partField.value) {
        partField.value = requestedPath.split('/')[2];
        const notice = form.closest('.ttp-form-card').querySelector('[data-ttp-recovery-reference]');
        if (notice) notice.hidden = false;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ttpRestorePartReference, { once: true });
  } else {
    ttpRestorePartReference();
  }

  if (!window.ttpFormAccountabilityLoaded) {
    window.ttpFormAccountabilityLoaded = true;
    document.addEventListener('submit', function(event) {
      const form = event.target.closest('form.ttp-form');
      if (!form || form.dataset.ttpForwarding === 'true') return;
      const formTypeField = form.querySelector('[data-ttp-form-type]');
      const receiverField = form.querySelector('[data-ttp-receiver-url]');
      const receiverUrl = receiverField ? receiverField.value : '';
      if (!receiverUrl || receiverUrl.indexOf('/exec') === -1) return;

      event.preventDefault();
      form.dataset.ttpForwarding = 'true';

      const frameName = 'ttp-accountability-' + Date.now();
      const frame = document.createElement('iframe');
      frame.name = frameName;
      frame.hidden = true;
      document.body.appendChild(frame);

      const forward = document.createElement('form');
      forward.method = 'post';
      forward.action = receiverUrl;
      forward.target = frameName;
      forward.hidden = true;

      const values = { formType: formTypeField ? formTypeField.value : '' };
      form.querySelectorAll('[data-accountability-field]').forEach(function(field) {
        values[field.dataset.accountabilityField] = field.value;
      });

      Object.keys(values).forEach(function(key) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = values[key] || '';
        forward.appendChild(input);
      });

      document.body.appendChild(forward);
      forward.submit();
      window.setTimeout(function() { form.submit(); }, 700);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
